import React from 'react';
import { stats } from '../data/site';
export function StatsBar() {
  return <section aria-label="By the numbers" className="border-y border-ink-600 bg-ink text-ivory" data-id="element-202" data-mp="1tai1x90mmpqa">
      <dl className="mx-auto grid max-w-[1400px] grid-cols-2 divide-ink-600 px-6 lg:grid-cols-4 lg:divide-x lg:px-10" data-id="element-203" data-mp="1obexnqsh0njd">
        {stats.map(stat => <div key={stat.label} className="px-2 py-10 lg:px-10" data-id="element-204" data-mp="1jbsl7jkgvbbm">
            <dt className="sr-only" data-id="element-205" data-mp="1edr4v6efdq3u">{stat.label}</dt>
            <dd data-id="element-206" data-mp="1efbxgqh6iyz2">
              <span className="block font-display text-4xl text-brass-light lg:text-5xl" data-id="element-207" data-mp="19mit43pmhsni">
                {stat.value}
              </span>
              <span className="mt-2 block font-mono text-[10px] uppercase tracking-[0.22em] text-ivory/50" data-id="element-208" data-mp="15lywd18yor1w">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}